/** Cấu hình 3 BXH tác giả của tháng – dùng cho tab "BXH tác giả" trong Cài đặt */
const awardNote = 'Hiện chỉ trao huy hiệu, chưa trả xu (job trao giải đã tắt phần cộng xu).';

export const RANKING_TABS = [
  {
    key: 'excellent', title: 'Xuất sắc', icon: 'bi-bookmark-star-fill',
    intro: 'Điểm BXH Xuất sắc = Σ (số lượng trong tháng × điểm). Đặt 0 để không tính và ẩn tiêu chí khỏi thể lệ trên website.',
    groups: [
      {
        title: 'Cách tính điểm', fields: [
          {id: 'AUTHOR_POINT_VIEW', label: 'Mỗi lượt đọc', unit: 'điểm', placeholder: '1', hint: 'Mặc định 1'},
          {id: 'AUTHOR_POINT_COMMENT', label: 'Mỗi bình luận', unit: 'điểm', placeholder: '2', hint: 'Mặc định 2'},
          {id: 'AUTHOR_POINT_LOVE', label: 'Mỗi lượt tim', unit: 'điểm', placeholder: '0', hint: 'Mặc định 0'},
          {id: 'AUTHOR_POINT_FAVOURITE', label: 'Mỗi lượt yêu thích (đánh dấu)', unit: 'điểm', placeholder: '0', hint: 'Mặc định 0'},
          {id: 'AUTHOR_POINT_DONATE', label: 'Mỗi lượt donate', unit: 'điểm', placeholder: '0', hint: 'Mặc định 0'},
          {id: 'AUTHOR_POINT_USER_ORDER', label: 'Mỗi người dùng mở khoá chương', unit: 'điểm', placeholder: '0', hint: 'Mặc định 0'},
          {id: 'AUTHOR_POINT_ORDER', label: 'Mỗi lần mở khoá chương', unit: 'điểm', placeholder: '0', hint: 'Mặc định 0'},
        ],
      },
      {
        title: 'Giải thưởng', note: awardNote, fields: [
          {id: 'AWARD_AUTHOR_TOP_MONTH_EXCELLENT', label: 'Xu thưởng theo từng top', type: 'list', unit: 'xu', maxItems: 10,
            hint: 'Số top được trao = số dòng (tối đa 10 – số huy hiệu có sẵn)'},
          {id: 'AUTHOR_EXCELLENT_MIN_VIEW', label: 'Lượt đọc tối thiểu trong tháng để nhận giải', unit: 'lượt đọc', placeholder: '0',
            hint: 'Tác giả chưa đạt không được xét, hạng chuyển cho người kế tiếp. Mặc định 0 = không giới hạn'},
        ],
      },
    ],
  },
  {
    key: 'favorite', title: 'Yêu thích', icon: 'bi-bookmark-heart-fill', unused: true,
    intro: 'BXH Yêu thích đang tạm ẩn trên website và tạm dừng trao giải. Điểm vẫn được tính để theo dõi.',
    groups: [
      {
        title: 'Cách tính điểm', fields: [
          {id: 'AUTHOR_FAV_POINT_FOLLOW', label: 'Mỗi lượt theo dõi tác giả', unit: 'điểm', placeholder: '10', hint: 'Mặc định 10'},
          {id: 'AUTHOR_FAV_POINT_FAVOURITE', label: 'Mỗi lượt yêu thích (đánh dấu)', unit: 'điểm', placeholder: '1', hint: 'Mặc định 1'},
          {id: 'AUTHOR_FAV_POINT_LOVE', label: 'Mỗi lượt tim', unit: 'điểm', placeholder: '1', hint: 'Mặc định 1'},
        ],
      },
      {
        title: 'Giải thưởng', note: awardNote, fields: [
          {id: 'AWARD_AUTHOR_TOP_MONTH_FAVORITE', label: 'Xu thưởng theo từng top', type: 'list', unit: 'xu', maxItems: 3,
            hint: 'Số top được trao = số dòng (tối đa 3)'},
        ],
      },
    ],
  },
  {
    key: 'hard', title: 'Chăm chỉ', icon: 'bi-fire', unused: true,
    intro: 'BXH Chăm chỉ đang tạm ẩn trên website và tạm dừng trao giải. Điểm vẫn được tính để theo dõi.',
    groups: [
      {
        title: 'Cách tính điểm', fields: [
          {id: 'AUTHOR_HARD_POINT_CHAPTER', label: 'Mỗi chương xuất bản trong tháng', unit: 'điểm', placeholder: '1', hint: 'Mặc định 1'},
          {id: 'AUTHOR_HARD_MIN_CHAPTER_VIEW', label: 'Lượt đọc tối thiểu để chương được tính', unit: 'lượt đọc', placeholder: '30', hint: 'Mặc định 30'},
        ],
      },
      {
        title: 'Giải thưởng', note: awardNote, fields: [
          {id: 'AWARD_AUTHOR_TOP_MONTH_HARD_WORKING', label: 'Xu thưởng theo từng top', type: 'list', unit: 'xu', maxItems: 3,
            hint: 'Số top được trao = số dòng (tối đa 3)'},
        ],
      },
    ],
  },
];

export const RANKING_IDS = RANKING_TABS.flatMap((t) => t.groups.flatMap((g) => g.fields.map((f) => f.id)));
